var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDedicatedsupport(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2151",
    "data-name": "Group 2151",
    transform: "translate(-992 -1710)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(992 1710)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_2_",
    transform: "translate(979.199 1720.307)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_120",
    "data-name": "Group 120",
    transform: "translate(25.274)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_119",
    "data-name": "Group 119",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_214",
    "data-name": "Path 214",
    d: "M53.918,281.756a8.565,8.565,0,0,1-6.933,3.538H42.99a3.192,3.192,0,0,1-3-2.1,10.132,10.132,0,0,1-1.613-.638,10.866,10.866,0,0,1-3.013-2.23,12.866,12.866,0,0,0-10.09,12.561v.8a2,2,0,0,0,2,2H58.327a2,2,0,0,0,2-2v-.8A12.856,12.856,0,0,0,53.918,281.756Z",
    transform: "translate(-25.274 -256.304)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_215",
    "data-name": "Path 215",
    d: "M93.887,19.894a2.278,2.278,0,0,0,2-1.18l.031.083.009.025a8.894,8.894,0,0,0,5.015,5.28,3.188,3.188,0,0,1,2.7-1.494h3.994a2.236,2.236,0,0,0,1.094-.294,4.514,4.514,0,0,0,1.29-1.49,11.518,11.518,0,0,0,1-2.111,2.29,2.29,0,0,0,.63.726v.979a4.018,4.018,0,0,1-4.014,4.014h-3.994a1.367,1.367,0,0,0,0,2.735h3.994a6.756,6.756,0,0,0,6.748-6.748v-.979a2.275,2.275,0,0,0,.912-1.823v-5.7a2.275,2.275,0,0,0-.946-1.848,10.932,10.932,0,0,0-21.795,0,2.275,2.275,0,0,0-.946,1.848v5.7A2.28,2.28,0,0,0,93.887,19.894Zm9.565-17.159a8.209,8.209,0,0,1,8.157,7.385,2.287,2.287,0,0,0-.64.792c-1.29-3.366-4.17-5.71-7.517-5.71-3.418,0-6.252,2.424-7.512,5.7l-.005.014a2.287,2.287,0,0,0-.64-.792A8.209,8.209,0,0,1,103.452,2.735Z",
    transform: "translate(-85.924)",
    fill: "#fafafa"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDedicatedsupport);
export default __webpack_public_path__ + "static/media/dedicatedsupport.d5da886ee5a16757937bd684ce420521.svg";
export { ForwardRef as ReactComponent };